import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @param data
 * @param token
 * @returns {Promise<AxiosResponse<*>>}
 * @constructor
 */
const VerifyEmailRequest = (data: any[] = {}, token: string = ""): Promise<AxiosResponse<*>> =>
    Request.post(`/advisors/verify-email/${token}`, data);

export default VerifyEmailRequest;